import type { SVGProps } from 'react';

export const SvgIconCategory220 = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.375 14.125H27.375V25.125C27.375 25.3902 27.2696 25.6446 27.0821 25.8321C26.8946 26.0196 26.6402 26.125 26.375 26.125H6.375C6.10978 26.125 5.85543 26.0196 5.66789 25.8321C5.48036 25.6446 5.375 25.3902 5.375 25.125V14.125Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.37597 14.1282L26.626 8.42816L25.5885 4.56566C25.5552 4.43854 25.4969 4.31934 25.417 4.21503C25.3371 4.11073 25.2372 4.02343 25.1231 3.95823C25.009 3.89304 24.883 3.85128 24.7526 3.83538C24.6222 3.81948 24.4899 3.82978 24.3635 3.86566L5.05097 9.04066C4.92361 9.07406 4.8041 9.13229 4.6993 9.21201C4.5945 9.29172 4.50647 9.39134 4.44027 9.50516C4.37407 9.61898 4.331 9.74475 4.31353 9.87526C4.29606 10.0058 4.30453 10.1384 4.33847 10.2657L5.37597 14.1282Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6367 5.92188L22.7617 9.45937"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.94922 8.26562L14.0617 11.8031"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
